import { formatPrice } from '@weft/services';
import type { Currency, RevenuePerMonthBreakdown, YearlyRevenue } from '@weft/types';
import { entries, isNullOrUndefined } from '@weft/utils';

export function getCustomerRevenueDateMap(yearlyRevenue: YearlyRevenue, revenueType: keyof RevenuePerMonthBreakdown, currency: Currency) {
  return entries(yearlyRevenue).reduce((formattedRevenuePerMonth, [year, revenuePerMonth]) => {
    entries(revenuePerMonth).forEach(([monthKey, revenuePerMonthBreakdown]) => {
      if (isNullOrUndefined(revenuePerMonthBreakdown)) {
        return;
      }

      const revenue = revenuePerMonthBreakdown[revenueType];
      const formattedRevenue = formatPrice(revenue ?? 0, currency);

      formattedRevenuePerMonth.set(`${monthKey} ${year}`, formattedRevenue);
    });

    return formattedRevenuePerMonth;
  }, new Map<string, string>());
}